/**
 * Created by daniel on 01/05/17.
 */

import React, {Component} from 'react';
import {RaisedButton, TextField, Toggle} from "material-ui";
import * as _ from "lodash";

class ComponentSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {...props.currentItem};
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({...nextProps.currentItem});
  }
  
  render() {
    if (!this.props.currentItem) {
      return (
        <div style={{
          width: "100%",
          textAlign: "center",
          paddingTop: "50px",
        }}>Select an item to edit its properties.</div>
      );
    }
    
    let makeToggle = (value, key) => {
      return (
        <Toggle
          key={key}
          style={{width: "100%"}}
          label={ _.upperFirst(_.lowerCase(key))}
          labelPosition="right"
          toggled={value}
          onClick={(e) => {
            let o = {};
            o[key] = !value;
            this.props.update(o);
          }}
        />
      )
    };
    
    let makeText = (value, key) => {
      return (
        <TextField
          key={key}
          style={{width: "100%"}}
          multiLine={true}
          //disabled={key.search(/config.+/) >= 0}
          floatingLabelText={ _.upperFirst(_.lowerCase(key))}
          value={_.isString(value) ? value : JSON.stringify(value,null,'\t')}
          onChange={(e) => {
            let o = {};
            o[key] = _.isString(value) ? e.currentTarget.value : JSON.parse(e.currentTarget.value);
            this.props.update(o);
          }}
        />
      )
    };
    
    let contentControls = [];
    _.forOwn(this.props.currentItem, (value, key) => {
      if (true || key.match(/content.+/)) {
        if (_.isBoolean(value)) {
          contentControls.push(
            makeToggle(value, key)
          )
        } else {
          contentControls.push(
            makeText(value, key)
          )
        }
      }
    });
    
    let {contentId, contentParentId, ...defaults} = this.props.currentItemDefaults;
    
    return (
      <div>
        <RaisedButton
          label="Reset item configuration"
          secondary={true}
          onClick={ (e) => {
            this.props.update(defaults);
          }}
        />
        {contentControls.map((item) => item)}
      </div>
    );
  }
}

export default ComponentSettings;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ToolBox/ComponentSettings.js